export const getBrandName = () => {
  const hostname =
    typeof window !== "undefined"
      ? window.location.hostname
      : "";
  const isGapalyzeDomain = hostname === "www.gapalyze.com" || hostname === "demo.gapalyze.com" || hostname === "localhost";

  const brandName = isGapalyzeDomain ? "Gapalyze Labs" : "Throughout Technologies";//hello@gapalyze.com
  const address = isGapalyzeDomain ? "2 Ganesh Puri Colony, Khajrana, Indore, Madhya Pradesh, 452016" : "103, Sanghi Manor, Yeshwant Niwas Rd, Maan Sarovar, Indore, Madhya Pradesh, 452003";//hello@gapalyze.com
  const phone = isGapalyzeDomain ? "+91 6262606167" : "9630303150";//hello@gapalyze.com
  const mail = isGapalyzeDomain ? "hello@gapalyze.com" : "hello@throughouttechnologies.com"
  const normalizedBrand = brandName.toLowerCase().replace(/\s+/g, '');
  const website = isGapalyzeDomain
  ? "https://www.gapalyze.com"
  : "https://www.marketplace.throughouttechnologies.com";

  const linkedInUrl = "https://www.linkedin.com/company/gapalyze-labs";
  const facebookUrl = "https://www.facebook.com/profile.php?id=61584860631846";
  const instagrameUrl = "https://www.instagram.com/gapalyze_labs/";

  const effectiveDate = 'October 7, 2025'

  return {
    brandName,
    normalizedBrand,
    isGapalyzeDomain,
    mail,
    website,
    effectiveDate,
    phone,
    address,
    linkedInUrl,
    facebookUrl,
    instagrameUrl
  };
};
